import { Routes } from '@angular/router';
import { AuthenticationPageComponent, MustBeAuthenticatedGuard } from './authentication-page/authentication-page.component';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { ChargepointsPageComponent } from './chargepoints-page/chargepoints-page.component';
import { ChargepointPageComponent } from './chargepoint-page/chargepoint-page.component';
import { EventsPageComponent } from './events-page/events-page.component';
import { OcppExpectedConfigurationPageComponent } from './ocpp-expected-configuration-page/ocpp-expected-configuration-page.component';
import { TracesPageComponent } from './traces-page/traces-page.component';
import { TraceCleanupPageComponent } from './trace-cleanup-page/trace-cleanup-page.component';
import { OcppSessionAnalysisPageComponent } from './ocpp-session-analysis-page/ocpp-session-analysis-page.component';
import { RedirectQueryParamGuard } from './redirect-query-param.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [MustBeAuthenticatedGuard, RedirectQueryParamGuard],
        children: [
            {
                path: '',
                component: PageLayoutComponent,
                children: [
                    {
                        path: '',
                        redirectTo: 'chargepoints',
                        pathMatch: 'full'
                    },
                    {
                        path: 'chargepoints',
                        children: [
                            {
                                path: '',
                                component: ChargepointsPageComponent,
                            },
                            {
                                path: ':id',
                                component: ChargepointPageComponent,
                            }
                        ]
                    },
                    {
                        path: 'events',
                        component: EventsPageComponent,
                    },
                    {
                        path: 'ocpp-expected-configuration',
                        component: OcppExpectedConfigurationPageComponent,
                    },
                    {
                        path: 'traces',
                        component: TracesPageComponent,
                    },
                    {
                        path: 'trace-cleanup',
                        component: TraceCleanupPageComponent,
                        data: { breadcrumb: 'Nettoyage des traces' }
                    },
                    {
                        path: 'session-stability',
                        component: OcppSessionAnalysisPageComponent,
                        data: { breadcrumb: 'Stabilité OCPP' }
                    }
                ]
            }
        ],
    },
    {
        path: "authentication",
        component: AuthenticationPageComponent,
    }
];
